import React from 'react';
import PropTypes from 'prop-types';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import { EventCard } from '../eventsStyles';

const CallbackCard = ({ event, ...props }) => {
  return (
    <EventCard
      icon={<PhoneCallbackIcon style={{ color: '#66BB6A' }} />}
      showEdit={true}
      event={event}
      showDelete={true}
      {...props}
      title="Call back"
    />
  );
};

CallbackCard.propTypes = {
  event: PropTypes.object,
};

export default CallbackCard;
